import { ImagePage } from "types";

export default {
  type: "imagePage",
  url: "assets/images/placeholderPages/music.jpg",
  title: { text: "Music" },
} as ImagePage;
